export const staticDataInKb = {
    biometrics: 20,
    signature: 20,
    inPerson: 50
};
export function calculateAge(birthday) { // birthday is a date
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export const formatAMPM = (date, isHourCheck, withAmPm) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    if (!isHourCheck)
        hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime;
    if (withAmPm)
        strTime = hours + ':' + minutes + ' ' + ampm;
    else
        strTime = hours + ':' + minutes;
    return strTime;
}

export const getTotalDaysInMonth = (month, year) =>
    (new Array(31)).fill('').map((v, i) => new Date(year, month - 1, i + 1)).filter(v => v.getMonth() === month - 1)


export const compareDateMonthDay = (date1, date2) => {

    let d1 = new Date(date1);
    d1.setHours(0, 0, 0, 0);
    let d2 = new Date(date2);
    d2.setHours(0, 0, 0, 0);
    return d1.getTime() === d2.getTime();
}

export const convertTimeToDate = (time) => {

    const [hours, minutes] = time.split(':');
    const tempDate = new Date();
    tempDate.setHours(hours);
    tempDate.setMinutes(minutes);
    tempDate.setFullYear(0);
    tempDate.setMonth(0);
    tempDate.setDate(0);
    return tempDate;
}
export function nepaliToEnglishNumber(nepaliNumStr) {
    if (nepaliNumStr) {
        const nepaliDigits = '०१२३४५६७८९';
        return nepaliNumStr.replace(/[०-९]/g, (char) => nepaliDigits.indexOf(char));
    }
}

export function englishToNepaliNumber(englishNumStr) {
    if (englishNumStr) {
        const nepaliDigits = '०१२३४५६७८९';
        return englishNumStr.replace(/[0-9]/g, (char) => nepaliDigits[char]);
    }
}
export function isValidDateForYYYYMMDD(dateStr) {
    // Split the input string to get year, month, and day
    const [year, month, day] = dateStr.split('-').map(Number);

    // Check if the input format is correct and the values are valid numbers
    if (!year || !month || !day || month > 12 || month < 1 || day < 1) {
        return false;
    }

    // Create a date object with the provided year, month (0-indexed), and day
    return true;
}